import { render, staticRenderFns } from "./auth-form-input-password.vue?vue&type=template&id=a23c7cfa&scoped=true"
import script from "./auth-form-input-password.vue?vue&type=script&lang=js"
export * from "./auth-form-input-password.vue?vue&type=script&lang=js"
import style0 from "./auth-form-input-password.vue?vue&type=style&index=0&id=a23c7cfa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a23c7cfa",
  null
  
)

export default component.exports